module.exports = __webpack_public_path__ + "img/average-call.1125925e.png";